// extracted by mini-css-extract-plugin
export default {"scope":"U6Unm","item":"cCetm","icon":"_3mGmR"};